import { Buildings, HouseLine } from "@phosphor-icons/react";
import * as React from "react";
import styles from "../Navbar.module.css";

export const MobileSolutionsContent: React.FC = () => {
  return (
    <div className={styles.mobileDropdownContent}>
      <a
        href="/solutions/companies-with-procurement"
        className={styles.mobileDropdownItem}
      >
        <div className={`${styles.productIcon} ${styles.withProcurementIcon}`}>
          <Buildings size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <span className={styles.mobileDropdownItemTitle}>
            Companies with Procurement
          </span>
          <span className={styles.mobileDropdownItemDescription}>
            Scale your procurement team&apos;s impact with AI-powered agents
          </span>
        </div>
      </a>

      <a
        href="/solutions/companies-without-procurement"
        className={styles.mobileDropdownItem}
      >
        <div
          className={`${styles.productIcon} ${styles.withoutProcurementIcon}`}
        >
          <HouseLine size={19} weight="fill" />
        </div>
        <div className={styles.mobileDropdownItemText}>
          <span className={styles.mobileDropdownItemTitle}>
            Companies without Procurement
          </span>
          <span className={styles.mobileDropdownItemDescription}>
            Get enterprise-grade procurement capabilities without building a
            team
          </span>
        </div>
      </a>
    </div>
  );
};
